export default "__VITE_ASSET__B2A746SC__"